import React, { Component } from "react";
import injectSheet from "react-jss";
// import Color from 'color'
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { flexUtils, palette } from "../../../Theme/Theme";
import ScrollableAnchor from "react-scrollable-anchor";
import { configureAnchors } from "react-scrollable-anchor";
import styled from "styled-components";
import { keyframes } from "styled-components";
import play from "../../../../assets/play.png";
import { Draggable } from "react-beautiful-dnd";
import _ from "lodash";
import * as TempActions from '../../../Actions/TempPlaylistActions'
import { isMobile } from 'react-device-detect'
configureAnchors({ offset: -60, scrollDuration: 700 });

const FadeIn = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;
const Container = styled.div`
  display: flex;
  ${'' /* background-color: blue; */}
  transition: all .7s;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  ${'' /* width: 90vw; */}
  width: ${props => props.isMobile ? '95vw' : '43vw' };
  margin: 1rem;
  height: ${props => props.isMobile ? '7rem' : '10.17vw' };
  min-height: ${props => props.isMobile ? '7rem' : '10.17vw' };
  max-height: ${props => props.isMobile ? '7rem' : '10.17vw' };
  border: 1px solid black;
  padding: 5px;
  &:hover {
    border: ${ props => props.isMobile ? 'none' : `1px solid ${palette.blue}`}
  }
`;
const Image = styled.img`  
  animation: ${props => (props.isFirstTime ? `${FadeIn} 2s linear` : "")};  
  ${'' /* width: 18vw; */}
  min-height: ${props => props.isMobile ? '5rem' : '10.17vw' };
  max-height: ${props => props.isMobile ? '5rem' : '10.17vw' };
  margin: 0.1vw;
  ${'' /* padding: 10px; */}
  padding-top: .4vw;
  padding-bottom: .4vw;
`;

const TextContainer = styled.div`
  width: ${props => props.isMobile ? '50vw' : '20vw' };
  height: ${props => props.isMobile ? '7rem' : '10.17vw' };
  display: flex;
  align-items: right;
  justify-content: space-around;
  flex-direction: column;
`;
const IconContainer = styled.div`
  width: ${props => props.isMobile ? '3rem' : '5vw' };
  height: ${props => props.isMobile ? '7rem' : '10.17vw' };
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  ${'' /* background-color: pink; */}
`;
const Icon = styled.div`
  transition: opacity .7s;
  color: ${palette.pink};;
  font-size: ${props => props.isMobile ? '.8rem' : '1.5vw'};
  opacity: ${props => props.isMobile ? '1' : `${props.opacity}`};
  &:hover {
    cursor: pointer;
    color: ${palette.pink};    
  }
`;
const Title = styled.div`
  color: ${palette.white};
  font-size: ${props => props.isMobile ? '.8rem' : '1.2vw' };
  padding-left: 1rem;
  padding-bottom: 1rem;
  font-weight: 600;
`;
const Description = styled.div`
  color: ${palette.white};
  padding-left: 1rem;
  font-size: ${props => props.isMobile ? '.4rem' : '.9vw' };
  font-weight: 500;
`;

class ShowView extends Component {
  state = {
    opacity: 0
  };
  render() {
    const { content } = this.props;
    return (
      <Draggable draggableId={`${content.id}`} index={this.props.index}>
        {provided => (
          <Container
            isMobile={isMobile}
            onMouseEnter={() => {
              this.setState({ opacity: 0.5 });
            }}
            onMouseLeave={() => {
              this.setState({ opacity: 0 });
            }}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            innerRef={provided.innerRef}
          >
            <Image
              isMobile={isMobile}
              index={this.props.index}
              isFirstTime={this.props.isFirstTime}
              src={content.thumbnail}
              alt={""}
            />
            <TextContainer isMobile={isMobile}>
              <Title isMobile={isMobile}>{content.title}</Title>
              <Description isMobile={isMobile}>{this.getDescription()}</Description>
            </TextContainer>
            <IconContainer isMobile={isMobile}>
              <Icon
                isMobile={isMobile}
                onMouseEnter={() => {
                  this.setState({ opacity: 1 });
                }}
                onMouseLeave={() => {
                  this.setState({ opacity: 0.5 });
                }}
                opacity={`${isMobile ?  1 : this.state.opacity}`}
                className="fas fa-trash-alt"
                onClick={this.delete}
              />
            </IconContainer>
          </Container>
        )}
      </Draggable>
    );
  }

  delete = () => {
    // console.log(this.props.content)
    this.props.dispatch({type: 'ITEM_MOVE_BEGIN'})
    this.props.dispatch(TempActions.deleteVideo(this.props.content.id))
  }

  getDescription = () => {
    const { content } = this.props;
    let index;
    let array = _.chain(this.props.library.view)
      .map("contentList")
      .flatten()
      .value();
    index = _.findIndex(array, obj => {
      return obj.id === content.video_id;
    });
    return array[index].description;
  };
}

const mapStateToProps = state => {
  return {
    user: state.mainState.user,
    library: state.mainState.library,
    isFirstTime: state.tempState.isFirstTime
  };
};

export default withRouter(connect(mapStateToProps)(ShowView));



// WEBPACK FOOTER //
// ./src/js/Components/Home/Playlists/PlayListItem.jsx